import { useState } from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import { FaAnglesRight } from "react-icons/fa6";
import { FaFacebookF, FaLinkedinIn, FaInstagram, FaTwitter, FaWhatsapp } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { FaSquareThreads } from "react-icons/fa6";
import "./Header.css";
import {
  FaYoutube,

  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";
const logo = "./main_logos.png";
const image23 = "/images/demo7.png";
const image24 = "/images/demo66.png";
const image27 = "/images/demo4.png";
const image277 = "/images/demo3.png";
const image2777 = "/images/demo2.png";
const image2779 = "/images/logo1.png";

function Header() {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showMega, setShowMega] = useState(false);


  const handleMenuClick = () => {
    setShowOffcanvas(false);
    setShowMega(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  
  const handleMegaItemClick = () => {
    setShowMega(false);
    setShowOffcanvas(false); 
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      {/* TOP MARQUEE */}
      <div className="theaderHeader">
        <div className="marquee">
          <div className="marquee-content">
            <span>📢 Premium & Delicate Garment Care</span>
            <span className="divider">|</span>
            <span>
              Get 30% Cashback on your first laundry order. Use Code:
              <strong className="code"> APP30 </strong>
            </span>
            <span className="divider">|</span>
            <span>5% Cashback on your first laundry order. T&C Apply</span>

            {/* Duplicate for smooth infinite scroll */}
            <span>📢 Premium & Delicate Garment Care</span>
            <span className="divider">|</span>
            <span>
              Get 30% Cashback on your first laundry order. Use Code:
              <strong className="code"> APP30 </strong>
            </span>
            <span className="divider">|</span>
            <span>5% Cashback on your first laundry order. T&C Apply</span>
          </div>
        </div>
      </div>

      {/* NAVBAR */}
      <Navbar expand="xl"  mt-5 className="main-navbar" fixed="top" style={{ backgroundColor: "#051c7b" }}>
        <Container fluid className="px-3 px-md-5 mt-5">
          {/* LOGO */}
          <Navbar.Brand as={NavLink} to="/" className="logo-wrapper">
            <img src={logo} alt="Logo" className="logo-img" />
          </Navbar.Brand>

          {/* TOGGLER */}
          <Navbar.Toggle
            aria-controls="offcanvasNavbar-expand-xl"
            style={{ backgroundColor: "white" }}
            onClick={() => setShowOffcanvas(true)}
          />

          {/* OFFCANVAS */}
          <Navbar.Offcanvas
            id="offcanvasNavbar-expand-xl"
            aria-labelledby="offcanvasNavbarLabel-expand-xl"
            placement="end"
            className="main-offcanvas"
            show={showOffcanvas}
            onHide={() => setShowOffcanvas(false)}
          >
            <Offcanvas.Header closeButton className="mobile-header">
              <Offcanvas.Title id="offcanvasNavbarLabel-expand-xl" style={{ color: "white" }}>
                Menu
              </Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body className="menu-body">
              {/* CENTER MENU */}
              <Nav className="main-menu">
                {/* MEGA MENU WRAPPER */}
                <div
                  className="services-mega-wrapper"
                  onMouseEnter={() => window.innerWidth >= 1200 && setShowMega(true)}
                  onMouseLeave={() => window.innerWidth >= 1200 && setShowMega(false)}
                >
                  <span
                    className="nav-link mega-trigger"
                    onClick={() => setShowMega((prev) => !prev)}
                  >
                    SERVICES {showMega ? "▴" : "▾"}
                  </span>

                  {showMega && (
                    <div className="mega-menu">
                      <div className="mega-grid">
                        {/* COLUMN 1 */}
                        <div className="mega-col">
                          <div className="main-service-logo">
                            <img src={image23} alt="Dry Cleaning" />
                            <h5>Dry Cleaning</h5>
                            <p>Dry Cleaning & Laundry</p>
                            <NavLink to="/expert-services" onClick={handleMegaItemClick} style={{ textDecoration: "none" }}>
                              <button className="header-main-button">
                                Learn More <FaAnglesRight />
                              </button>
                            </NavLink>
                          </div>
                        </div>

                        {/* COLUMN 2 */}
                        <div className="mega-col">
                          <div className="main-service-logo">
                            <img src={image24} alt="Wash & Fold" />
                            <h5>Wash & Fold</h5>
                            <p>Everyday Laundry</p>
                            <NavLink to="/washfold" onClick={handleMegaItemClick} style={{ textDecoration: "none" }}>
                              <button className="header-main-button">
                                Learn More <FaAnglesRight />
                              </button>
                            </NavLink>
                          </div>
                        </div>

                        {/* COLUMN 3 */}
                        <div className="mega-col">
                          <div className="main-service-logo">
                            <img src={image27} alt="Bed & Bath" />
                            <h5>Bed & Bath</h5>
                            <p>Laundry Home Linens</p>
                            <NavLink to="/drycleaning" onClick={handleMegaItemClick} style={{ textDecoration: "none" }}>
                              <button className="header-main-button">
                                Learn More <FaAnglesRight />
                              </button>
                            </NavLink>
                          </div>
                        </div>

                        {/* COLUMN 4 */}
                        <div className="mega-col">
                          <div className="main-service-logo">
                            <img src={image277} alt="Press Only" />
                            <h5>Press Only</h5>
                            <p>Pressing & Steaming</p>
                            <NavLink to="/press-only" onClick={handleMegaItemClick} style={{ textDecoration: "none" }}>
                              <button className="header-main-button">
                                Learn More <FaAnglesRight />
                              </button>
                            </NavLink>
                          </div>
                        </div>

                        {/* COLUMN 5 */}
                        <div className="mega-col">
                          <div className="main-service-logo">
                            <img src={image2777} alt="Shoe Care" />
                            <h5>Shoe & Care</h5>
                            <p>Cleaning & Restoration</p>
                            <NavLink to="/shoe-care" onClick={handleMegaItemClick} style={{ textDecoration: "none" }}>
                              <button className="header-main-button">
                                Learn More <FaAnglesRight />
                              </button>
                            </NavLink>
                          </div>
                        </div>

                        {/* COLUMN 6 */}
                        <div className="mega-col">
                          <div className="main-service-logo">
                            <img src={image2779} alt="Bag Care" />
                            <h5>Bag Care</h5>
                            <p>Cleaning & Restoration</p>
                            <NavLink to="/bagcare-section" onClick={handleMegaItemClick} style={{ textDecoration: "none" }}>
                              <button className="header-main-button">
                                Learn More <FaAnglesRight />
                              </button>
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <NavLink to="/laundry-offer" className="nav-link" onClick={handleMenuClick}>
                  OFFERS
                </NavLink>

                <NavLink to="/laundry-price" className="nav-link" onClick={handleMenuClick}>
                  PRICES
                </NavLink>

                <NavLink to="/booknow-laundry" className="nav-link order-btn-nav" onClick={handleMenuClick}>
                  <Button className="book-btn-header">ORDER NOW</Button>
                </NavLink>
              </Nav>

              {/* RIGHT SECTION (CALL BUTTON & MOBILE APP/SOCIAL LINKS) */}
              <div className="right-section">
                <Button
                  className="app-btn call-btn"
                  onClick={() => (window.location.href = "tel:+971545718455")}
                >
                  <i className="fas fa-phone-alt"></i> &nbsp; 0545718455
                </Button>

                {/* MOBILE EXTRA SECTION - Only visible on screens < 1200px */}
                <div className="mobile-bottom">
                  <div className="download-sectionsss">
                    <p>Download Our Mobile App</p>
                    <div className="store-buttons">
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                        alt="Google Play"
                      />
                      <img
                        src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                        alt="App Store"
                      />
                    </div>
                  </div>

                  <div className="social-section">
                    <p>Follow Us</p>
                    <div className="social-icons">
                     <a href="https://www.facebook.com/share/1BYEnr3gtA/" target="block">
                                   <FaFacebookF />
                                 </a>
                                 <a href="https://www.threads.com/@fnclaundryofficial" target="block">
                                   <FaSquareThreads />
                                 </a>
                                 <a href="https://www.instagram.com/fnclaundryofficial"target="block">
                                   <FaInstagram />
                                 </a>
                                 <a href="https://www.youtube.com/@fnclaundryofficial" target="block">
                                   <FaYoutube />
                                 </a>
                                 <a href="https://www.linkedin.com/company/fnclaundryofficial/" target="block">
                                   <FaLinkedinIn />
                                 </a>
                    </div>
                  </div>
                </div>

              </div>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </div>
  );
}

export default Header;